export default __webpack_public_path__ + "static/media/hht1_song_08.091da133.png";